import * as React from "react";

interface ILabelProps {
    label: string;
    className?: string;
    useDiv?: boolean;
}

export default class LabelCtl extends React.PureComponent<ILabelProps> {

    render() {
        if (this.props.useDiv)
            return <div className={this.props.className ?? "label"}><span>{this.props.label}</span>{this.props.children}</div>;
        else
            return <label className={this.props.className}><span>{this.props.label}</span>{this.props.children}</label>;
    }
}